import React from 'react';
import { Link } from '@vtblife/uikit';

import { SuccessModal } from '@search/vtbeco-frontend-core/view/common/components/SuccessModal/SuccessModal';
import { useLkLinks } from '../../useLkLinks';

type Props = {
    onClose: () => void;
    email: string;
    isMobile?: boolean;
}

export const SubscriptionSuccessModal = ({
    isMobile,
    email,
    onClose
}: Props) => {
    const { savedSearchUrl } = useLkLinks();

    return (
        <SuccessModal
            onClose={onClose}
            isMobile={isMobile}
            title='Поиск сохранён'
            mobileDescription={<>
                Письма о новых объявлениях вы будете получать на почту <b>
                    {email}
                </b>.&nbsp;Управлять поисками вы можете в <Link
                    variant='primary-minor'
                    href={savedSearchUrl}
                    target='blank'
                >
                    Личном кабинете
                </Link>.
            </>}
            desktopDescription={<>
                Поиск сохранён.<br />
                Письма о новых объявлениях вы будете получать на почту <b>
                    {email}
                </b>.&nbsp;Управлять поисками вы можете в <Link
                    variant='primary-minor'
                    href={savedSearchUrl}
                    target='blank'
                >
                    Личном кабинете
                </Link>.
            </>}
        />
    );
};
